import ViewOrderList from './ViewOrderList';
import OnMap from './OnMap';

export  {ViewOrderList, OnMap} 


// WEBPACK FOOTER //
// ./src/components/Orders/SubComponentsRightContent/index.js